<template>
  <phone-frame>
    <div class="cover" :style="coverStyle">
      <p class="cover__title">{{ workflowLabel(title || DEFAULT_TITLE) }}</p>

      <div class="cover__actions">
        <div class="cover__button cover__button--secondary" :style="{ color: brand }">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d="M3 17H21C21.2833 17 21.521 17.096 21.713 17.288C21.905 17.48 22.0007 17.7173 22 18C21.9993 18.2827 21.9033 18.5203 21.712 18.713C21.5207 18.9057 21.2833 19.0013 21 19H3C2.71667 19 2.47933 18.904 2.288 18.712C2.09667 18.52 2.00067 18.2827 2 18C1.99933 17.7173 2.09533 17.48 2.288 17.288C2.48067 17.096 2.718 17 3 17ZM4 11.45L3.525 12.3C3.425 12.4833 3.275 12.6 3.075 12.65C2.875 12.7 2.68333 12.675 2.5 12.575C2.31667 12.475 2.2 12.325 2.15 12.125C2.1 11.925 2.125 11.7333 2.225 11.55L2.7 10.7H1.75C1.53333 10.7 1.35433 10.6293 1.213 10.488C1.07167 10.3467 1.00067 10.1673 1 9.95C0.999333 9.73267 1.07033 9.55367 1.213 9.413C1.35567 9.27233 1.53467 9.20133 1.75 9.2H2.7L2.225 8.4C2.125 8.21667 2.1 8.025 2.15 7.825C2.2 7.625 2.31667 7.475 2.5 7.375C2.68333 7.275 2.875 7.25 3.075 7.3C3.275 7.35 3.425 7.46667 3.525 7.65L4 8.45L4.475 7.65C4.575 7.46667 4.725 7.35 4.925 7.3C5.125 7.25 5.31667 7.275 5.5 7.375C5.68333 7.475 5.8 7.625 5.85 7.825C5.9 8.025 5.875 8.21667 5.775 8.4L5.3 9.2H6.25C6.46667 9.2 6.646 9.271 6.788 9.413C6.93 9.555 7.00067 9.734 7 9.95C6.99933 10.166 6.92833 10.3453 6.787 10.488C6.64567 10.6307 6.46667 10.7013 6.25 10.7H5.3L5.775 11.55C5.875 11.7333 5.9 11.925 5.85 12.125C5.8 12.325 5.68333 12.475 5.5 12.575C5.31667 12.675 5.125 12.7 4.925 12.65C4.725 12.6 4.575 12.4833 4.475 12.3L4 11.45ZM12 11.45L11.525 12.3C11.425 12.4833 11.275 12.6 11.075 12.65C10.875 12.7 10.6833 12.675 10.5 12.575C10.3167 12.475 10.2 12.325 10.15 12.125C10.1 11.925 10.125 11.7333 10.225 11.55L10.7 10.7H9.75C9.53333 10.7 9.35433 10.6293 9.213 10.488C9.07167 10.3467 9.00067 10.1673 9 9.95C8.99933 9.73267 9.07033 9.55367 9.213 9.413C9.35567 9.27233 9.53467 9.20133 9.75 9.2H10.7L10.225 8.4C10.125 8.21667 10.1 8.025 10.15 7.825C10.2 7.625 10.3167 7.475 10.5 7.375C10.6833 7.275 10.875 7.25 11.075 7.3C11.275 7.35 11.425 7.46667 11.525 7.65L12 8.45L12.475 7.65C12.575 7.46667 12.725 7.35 12.925 7.3C13.125 7.25 13.3167 7.275 13.5 7.375C13.6833 7.475 13.8 7.625 13.85 7.825C13.9 8.025 13.875 8.21667 13.775 8.4L13.3 9.2H14.25C14.4667 9.2 14.6457 9.271 14.787 9.413C14.9283 9.555 14.9993 9.734 15 9.95C15.0007 10.166 14.9297 10.3453 14.787 10.488C14.6443 10.6307 14.4653 10.7013 14.25 10.7H13.3L13.775 11.55C13.875 11.7333 13.9 11.925 13.85 12.125C13.8 12.325 13.6833 12.475 13.5 12.575C13.3167 12.675 13.125 12.7 12.925 12.65C12.725 12.6 12.575 12.4833 12.475 12.3L12 11.45ZM20 11.45L19.525 12.3C19.425 12.4833 19.275 12.6 19.075 12.65C18.875 12.7 18.6833 12.675 18.5 12.575C18.3167 12.475 18.2 12.325 18.15 12.125C18.1 11.925 18.125 11.7333 18.225 11.55L18.7 10.7H17.75C17.5333 10.7 17.3543 10.6293 17.213 10.488C17.0717 10.3467 17.0007 10.1673 17 9.95C16.9993 9.73267 17.0703 9.55367 17.213 9.413C17.3557 9.27233 17.5347 9.20133 17.75 9.2H18.7L18.225 8.4C18.125 8.21667 18.1 8.025 18.15 7.825C18.2 7.625 18.3167 7.475 18.5 7.375C18.6833 7.275 18.875 7.25 19.075 7.3C19.275 7.35 19.425 7.46667 19.525 7.65L20 8.45L20.475 7.65C20.575 7.46667 20.725 7.35 20.925 7.3C21.125 7.25 21.3167 7.275 21.5 7.375C21.6833 7.475 21.8 7.625 21.85 7.825C21.9 8.025 21.875 8.21667 21.775 8.4L21.3 9.2H22.25C22.4667 9.2 22.646 9.271 22.788 9.413C22.93 9.555 23.0007 9.734 23 9.95C22.9993 10.166 22.9283 10.3453 22.787 10.488C22.6457 10.6307 22.4667 10.7013 22.25 10.7H21.3L21.775 11.55C21.875 11.7333 21.9 11.925 21.85 12.125C21.8 12.325 21.6833 12.475 21.5 12.575C21.3167 12.675 21.125 12.7 20.925 12.65C20.725 12.6 20.575 12.4833 20.475 12.3L20 11.45Z" />
          </svg>
          {{ adminText('workflowsAll.login_with_code_05344e0', 'Login with code') }}
        </div>
        <div class="cover__button" :style="{ backgroundColor: brand }">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d="M3 10V4C3 3.71667 3.096 3.47933 3.288 3.288C3.48 3.09667 3.71733 3.00067 4 3H10C10.2833 3 10.521 3.096 10.713 3.288C10.905 3.48 11.0007 3.71733 11 4V10C11 10.2833 10.904 10.521 10.712 10.713C10.52 10.905 10.2827 11.0007 10 11H4C3.71667 11 3.47933 10.904 3.288 10.712C3.09667 10.52 3.00067 10.2827 3 10ZM5 9H9V5H5V9ZM3 20V14C3 13.7167 3.096 13.4793 3.288 13.288C3.48 13.0967 3.71733 13.0007 4 13H10C10.2833 13 10.521 13.096 10.713 13.288C10.905 13.48 11.0007 13.7173 11 14V20C11 20.2833 10.904 20.521 10.712 20.713C10.52 20.905 10.2827 21.0007 10 21H4C3.71667 21 3.47933 20.904 3.288 20.712C3.09667 20.52 3.00067 20.2827 3 20ZM5 19H9V15H5V19ZM13 10V4C13 3.71667 13.096 3.47933 13.288 3.288C13.48 3.09667 13.7173 3.00067 14 3H20C20.2833 3 20.521 3.096 20.713 3.288C20.905 3.48 21.0007 3.71733 21 4V10C21 10.2833 20.904 10.521 20.712 10.713C20.52 10.905 20.2827 11.0007 20 11H14C13.7167 11 13.4793 10.904 13.288 10.712C13.0967 10.52 13.0007 10.2827 13 10ZM15 9H19V5H15V9ZM19 21V19H21V21H19ZM13 15V13H15V15H13ZM15 17V15H17V17H15ZM13 19V17H15V19H13ZM15 21V19H17V21H15ZM17 19V17H19V19H17ZM17 15V13H19V15H17ZM19 17V15H21V17H19Z" />
          </svg>
          {{ adminText('workflowsAll.login_with_qr_code_09fa829', 'Login with QR code') }}
        </div>
      </div>
    </div>
  </phone-frame>
</template>

<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
import PhoneFrame from './phone-frame'
import { DEFAULT_HUE, getBrandColor, hexToHue } from '@/utils/color'

/*
  COR-1684: the conference app's first screen (WelcomeScreen in the app, Figma "Login").
  It mirrors the app rather than the admin mock: the event's `welcomeTitle` over its
  `welcomeBackground`, falling back to the app's default title, and to the flat brand
  colour when there is no photo. `welcomeSubtitle` is not shown in the app, so not here.
*/

// The app's strings.json auth.welcome.title.
const DEFAULT_TITLE = 'Welcome to CoreEvent conference app'

export default {
  mixins: [WorkflowDisplay],
  name: 'cover-preview',
  components: { PhoneFrame },
  props: {
    image: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    primaryColor: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      DEFAULT_TITLE,
    }
  },
  computed: {
    brand() {
      const hue = hexToHue(this.primaryColor)

      return getBrandColor(hue === null ? DEFAULT_HUE : hue)
    },
    coverStyle() {
      return {
        backgroundColor: this.brand,
        backgroundImage: this.image ? `url("${this.image}")` : 'none',
      }
    },
  },
}
</script>

<style scoped>
.cover {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  padding: 88px 24px 24px;
  background-position: center;
  background-size: cover;
  font-family: 'Raleway', sans-serif;
  font-weight: 900;
  font-feature-settings: 'lnum' 1, 'pnum' 1;
  text-transform: uppercase;
}

.cover__title {
  margin: 0;
  font-size: 48px;
  line-height: 1;
  color: #ffffff;
  word-break: break-word;
}

.cover__actions {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.cover__button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 24px;
  border-radius: 32px;
  font-size: 18px;
  line-height: 24px;
  letter-spacing: -0.27px;
  white-space: nowrap;
  color: #ffffff;
}

.cover__button--secondary {
  background-color: #ffffff;
}
</style>
